var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"商品 ID","prop":"id"}}),_c('el-table-column',{attrs:{"label":"商品名称","prop":"name"}}),_c('el-table-column',{attrs:{"label":"描述","prop":"desc"}})],1),_c('div',[_vm._v("商户资质详情")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }